import { Swiper } from 'swiper'

const fn = {
  init: () => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      document.querySelectorAll('.stats-slider').forEach((el) => fn.setupSlider(el))
    }
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper-container')

    const opts = {
      slidesPerView: 2,
      freeMode: true,
      on: {
        sliderFirstMove: () => {
          el.querySelector('.scroll-indicator').classList.add('hidden')
        },
      },
    }

    new Swiper(container, opts)
  },
}

export default {
  can: () => true,
  run: fn.init,
}
